import React from 'react'
import type { SwitchFieldProps } from './Checkbox.types'

export default function SwitchField({
  name,
  checked,
  label,
  helperText,
  required,
  disabled,
  onChange,
}: SwitchFieldProps) {
  return (
    <div className="rd-switch-wrapper">
      <label className={`rd-switch rd-switch--label-after${!label ? ' rd-switch--no-label' : ''}`}>
        <input
          className="rd-switch__input"
          type="checkbox"
          name={name}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
        />
        <span className="rd-switch__track">
          <span className="rd-switch__knob" />
        </span>
        {label && (
          <span className="rd-switch__label">
            {label}
            {required && <span className="rd-switch__required">*</span>}
          </span>
        )}
      </label>
      {helperText && <span className="rd-switch__help-text">{helperText}</span>}
    </div>
  )
}
